<div class="card">
  <div class="card-header flex-between">
    <div class="flex-start">
      <button class="btn btn-light" (click)="backToReports()">
        <i class="fa fa-arrow-left"></i> Back to Race Reports
      </button>
      <h5 class="pb-0 mb-0">Race Visualization</h5>
    </div>
    <div class="flex-start">
      <!-- Layout toggle buttons -->
      <div class="layout-controls">
        <button class="btn btn-primary-soft" [ngClass]="{'active': layoutMode === 'vertical'}"
                (click)="setLayout('vertical')" title="Stack vertically">
          <i class="fa fa-arrows-v"></i>
        </button>
        <button class="btn btn-primary-soft" [ngClass]="{'active': layoutMode === 'horizontal'}"
                (click)="setLayout('horizontal')" title="Place side by side">
          <i class="fa fa-arrows-h"></i>
        </button>
      </div>
      <button class="btn btn-primary-soft flex-start" (click)="refresh()">
        <i class="fa fa-refresh color-inherit" aria-hidden="true"></i>
        Refresh
      </button>
    </div>
  </div>

  <div class="card-body visualization-container" [ngClass]="{'layout-horizontal': layoutMode === 'horizontal'}">
    <div class="race-details">
      <div class="details-group">
        <h6>Race Information</h6>
        <div class="detail-item">
          <span class="label">Race Number:</span>
          <span class="value">{{ data.race.SquentialRaceOrderNumber }}</span>
        </div>
        <div class="detail-item">
          <span class="label">Race ID:</span>
          <span class="value">{{ data.race.ExternalRaceId }}</span>
        </div>
        <div class="detail-item">
          <span class="label">Date:</span>
          <span class="value">{{ data.event.date | date : "mediumDate" }}</span>
        </div>
        <div class="detail-item">
          <span class="label">Race Length:</span>
          <span class="value">{{ data.race.race_length }}m</span>
        </div>
      </div>

      <div class="details-group">
        <h6>Event Details</h6>
        <div class="detail-item">
          <span class="label">Event ID:</span>
          <span class="value">{{ data.event.external_event_id }}</span>
        </div>
        <div class="detail-item">
          <span class="label">Venue:</span>
          <span class="value">{{ data.event.venue_name }}</span>
        </div>
        <div class="detail-item">
          <span class="label">Venue ID:</span>
          <span class="value">{{ data.event.external_venue_id }}</span>
        </div>
      </div>

      <div class="details-group">
        <h6>Additional Info</h6>
        <div class="detail-item">
          <span class="label">Jurisdiction:</span>
          <span class="value">{{ data.event.JurisdictionCode }}</span>
        </div>
        <div class="detail-item" *ngIf="data.event.pc">
          <span class="label">PC Number:</span>
          <span class="value">{{ data.event.pc }}</span>
        </div>
      </div>
    </div>

    <div class="horse-details-table">
      <table class="table table-docs table-hover">
        <tbody>
          <tr class="horse-names-row">
            <th>Name</th>
            <td *ngFor="let horse of data.entrants">{{ horse.AnimalName }}</td>
          </tr>
          <tr>
            <th>SCN</th>
            <th *ngFor="let horse of data.entrants">{{ horse.StartNumber }}</th>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="visualization-sections">
      <!-- Video Replay Section - Independent from map errors -->
      <div class="form-section video-section">
        <div class="form-section-header">Video Replay</div>
        <div class="form-section-body">
          <div *ngIf="videoLoading" class="loading-spinner">
            <span class="spinner-border"></span>
            <span>Loading video replay...</span>
          </div>

          <div *ngIf="videoError && !videoLoading" class="error-message">
            <i class="fa fa-exclamation-circle"></i> {{ videoError }}
          </div>

          <div *ngIf="videoUrl && !videoLoading" class="video-container">
            <video
              #videoPlayer
              [poster]="thumbnailUrl"
              class="video-player"
              [ngClass]="{'fullscreen-video': isFullscreen}"
              preload="metadata"
              (timeupdate)="onVideoTimeUpdate()"
              (loadedmetadata)="onVideoLoaded()"
              (ended)="onVideoEnded()"
              (error)="onVideoError()">
              <source [src]="videoUrl" type="video/mp4">
              Your browser does not support HTML5 video.
            </video>
            <div class="video-controls light-mode">
              <div class="video-controls-top">
                <div class="playback-controls">
                  <button class="btn btn-icon" (click)="jumpBackward(5)" title="Jump back 5 seconds">
                    <i class="fa fa-backward"></i>
                  </button>
                  <button class="btn btn-icon play-btn" (click)="togglePlayPause()">
                    <i class="fa" [ngClass]="isPlaying ? 'fa-pause' : 'fa-play'"></i>
                  </button>
                  <button class="btn btn-icon" (click)="jumpForward(5)" title="Jump forward 5 seconds">
                    <i class="fa fa-forward"></i>
                  </button>
                </div>

                <div class="time-display">
                  <span>{{ formatTimeSimple(currentTime) }}</span>
                  <span> / </span>
                  <span>{{ formatTimeSimple(duration) }}</span>
                </div>

                <div class="right-controls">
                  <div class="speed-controls">
                    <button class="btn btn-sm" [ngClass]="{'btn-primary': videoPlaybackRate === 0.25, 'btn-outline-secondary': videoPlaybackRate !== 0.25}" (click)="setPlaybackRate(0.25)">0.25x</button>
                    <button class="btn btn-sm" [ngClass]="{'btn-primary': videoPlaybackRate === 0.5, 'btn-outline-secondary': videoPlaybackRate !== 0.5}" (click)="setPlaybackRate(0.5)">0.5x</button>
                    <button class="btn btn-sm" [ngClass]="{'btn-primary': videoPlaybackRate === 1, 'btn-outline-secondary': videoPlaybackRate !== 1}" (click)="setPlaybackRate(1)">1x</button>
                    <button class="btn btn-sm" [ngClass]="{'btn-primary': videoPlaybackRate === 1.5, 'btn-outline-secondary': videoPlaybackRate !== 1.5}" (click)="setPlaybackRate(1.5)">1.5x</button>
                    <button class="btn btn-sm" [ngClass]="{'btn-primary': videoPlaybackRate === 2, 'btn-outline-secondary': videoPlaybackRate !== 2}" (click)="setPlaybackRate(2)">2x</button>
                  </div>
                  <button class="btn btn-icon fullscreen-btn" (click)="toggleFullscreen()" title="Toggle fullscreen">
                    <i class="fa" [ngClass]="isFullscreen ? 'fa-compress' : 'fa-expand'"></i>
                  </button>
                </div>
              </div>
              <div class="progress-container">
                <div class="custom-progress-bar" #progressBarContainer (mousedown)="onProgressBarClick($event)">
                  <div class="progress-track">
                    <div class="progress-buffered" [style.width.%]="bufferProgress"></div>
                    <div class="progress-fill" [style.width.%]="videoProgress"></div>
                  </div>
                  <div class="progress-handle" [style.left.%]="videoProgress"
                      (mousedown)="startDrag($event)"
                      [class.active]="isDragging"></div>
                  <div class="progress-hover-time" [style.left.px]="hoverPosition">
                    {{ formatTimeSimple(hoverTime) }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="!videoUrl && !videoLoading && !videoError" class="video-placeholder">
            <h4>Video Coming Soon</h4>
          </div>
        </div>
      </div>

      <!-- Map Visualization Section - Independent from video errors -->
      <div class="form-section map-section">
        <div class="form-section-header">Map Visualization</div>
        <div class="form-section-body">
          <div *ngIf="loading" class="loading-spinner">
            <span class="spinner-border"></span>
            <span>Loading map visualization...</span>
          </div>

          <div *ngIf="apiError" class="error-message">
            <i class="fa fa-exclamation-circle"></i> {{ apiError }}
          </div>

          <div class="iframe-container" *ngIf="iframeHtml && !loading">
            <iframe [srcdoc]="iframeHtml" frameborder="0"></iframe>
          </div>

          <div *ngIf="!iframeHtml && !loading && !apiError" class="no-iframe">
            Map visualization not available.
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
